<template>
  <button
    type="button"
    aria-label="Afficher mes informations"
    class="button-avatar"
    @click="handleClickAvatar"
  >
    <img v-if="profile.mediaAvatar" :src="profile.mediaAvatar.urlCompressed" />
    <img v-else class="solid" src="~/assets/images/avatar.png" />
    <h5 v-if="isSwitchableProfile" class="name">
      {{ user.firstname || profile.displayName }}
    </h5>
    <icon class="icon" name="material-symbols:keyboard-arrow-down-rounded" />
    <div class="badge">
      <BadgeNotification v-if="!isSwitchableBackToParent" :count="count" />
    </div>
  </button>
</template>
<script lang="ts" setup>
import DialogSettings from '~/components/dialog/settings/DialogSettings.vue';
import DialogProfileSwitch from '~/components/dialog/profile/DialogProfileSwitch.vue';
import DialogSettingsPreferences from '~/components/dialog/settings/preferences/DialogSettingsPreferences.vue';
const profile = useProfileStore();
const user = useUserStore();
const dialog = useDialogStore();
const { isSwitchableBackToParent, isSwitchableProfile } =
  useFamilySwitchMember();

const { notifications } = useNotificationsStore();

const count = computed(
  () => notifications.get(NotificationTypes.Trophies).length
);

const handleClickAvatar = () => {
  if (isSwitchableProfile.value) {
    dialog.open(DialogProfileSwitch, {
      level: DialogLevel.Settings,
      position: 'top-right',
    });
  } else {
    dialog.open(DialogSettings, {
      level: DialogLevel.Settings,
      position: 'top-right',
    });
  }
};

const route = useRoute();

const hasHashSettings = computed(() => {
  return route.hash.includes('#/settings');
});

watchEffect(() => {
  if (hasHashSettings.value) {
    const boxName = route.hash.includes('#/settings/')
      ? route.hash.replace('#/settings/', '')
      : null;

    const defaultPaths = ['root'];

    if (boxName) defaultPaths.push(boxName);
    dialog.open(DialogSettingsPreferences, {
      level: DialogLevel.Settings,
      position: 'top-right',
      fromUserDialog: true,
      defaultPaths,
    });
    const path = route.fullPath.replace(route.hash, '');
    navigateTo(path);
  }
});

onMounted(async () => {
  await profile.getAvatar();
});
</script>
<style lang="scss" scoped>
.button-avatar {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;

  // width: 100%;
  height: 4rem;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  transition: background-color 300ms $ease-out-quad;
  border-width: var(--stroke_thickness_n);
  border-radius: 2.5rem;
  background-color: var(--color_secondary);
  cursor: pointer;
  gap: 0.4rem;

  @include above('l') {
    height: 4.4rem;
    padding: 0.5rem 1rem 0.5rem 0.8rem;
    border-width: var(--stroke_thickness_n);
    border-radius: 2.2rem;
  }

  .name {
    max-width: 16rem;
    overflow: hidden;
    color: var(--color_neutral_50);
    text-overflow: ellipsis;
    white-space: nowrap;
    @include font('s', 500, 'secondary');
    @include below('s') {
      max-width: 12rem;
    }
    @include above('l') {
      @include font('n', 500, 'secondary');
    }
    @include mobile {
      display: none;
    }
  }

  .icon {
    display: block;
    transition: transform 300ms $ease-out-quad;
    color: var(--color_neutral_50);
    @include above('l') {
      width: 2.6rem;
    }
  }

  img {
    width: auto;
    height: 100%;
    object-fit: contain;
    @include above('l') {
      height: 2.8rem;
    }

    transition: transform 300ms $ease-out-back;
    &.solid {
      border-radius: 50%;
      background-color: var(--color_neutral_50);
    }
  }

  &:hover,
  &:focus {
    @include above('l') {
      .icon {
        transform: translateY(0.3rem);
      }
      img {
        transform: scale(1.3);
      }
      .badge {
        transform: translateY(0.4rem) translateX(-0.4rem);
      }
    }
  }
}

.badge {
  position: absolute;
  bottom: 0;
  left: 0;
  transition: transform 300ms $ease-out-back;
}
</style>
